import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';

                  
const Tab1 = ({ pageState, itemCodeList,handleChange}) => {
  // Add safe destructuring with fallbacks


  console.log(itemCodeList,"itemCodeList");
  


  return (
    <div className="row mb-3" style={{ border: "1px solid #00000059", borderRadius: "5px" }}>
      <div className="col-12">
        <p className="boxLabel m-0">Details</p>
      </div>

      <div className="col-6 ">
        <div className="mb-3">
          <Input
            id="SerialNo"
            label="Serial No"
            style={{
              height: "30px",
           
            }}
            value={pageState.serialNo}
            onChange={(e) => handleChange('serialNo', e.target.value)}
          />
        </div>
      </div>

      <div className="col-6">
        <div >
          <SelectSearch
            list={itemCodeList}
            label="Item Code"
            getOptionLabel={(item) => item?.isNew ? "+ Create New Item Code" : item?.name || ""}
            getOptionValue={(item) => item?.name || ""}
            value={pageState.itemCode}
            onChange={(val) => handleChange('itemCode', val)}
            createNewUrl="/master/item/create-item"
            createNewLabel="Create New Item Code"
          />
        </div>
      </div>
    </div>
  );
};

export default Tab1;